import React, { createContext, useContext, useState } from "react";
import { CURRENCIES, getDisplayCurrency, setDisplayCurrency } from "@/lib/api";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(getDisplayCurrency());
  const change = (code) => {
    setDisplayCurrency(code);
    setCurrency(code);
  };
  return (
    <CurrencyContext.Provider value={{ currency, change, currencies: CURRENCIES }}>
      <div className="contents" key={currency}>{children}</div>
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
